import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Brands from "@/components/Brands";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import FoundersCorner from "@/components/FoundersCorner";
import Clients from "@/components/Clients";
import Testimonials from "@/components/Testimonials";
import Enquiry from "@/components/Enquiry";
import MapSection from "@/components/MapSection";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Admin from "@/pages/Admin";

const Home = () => (
    <main className="bg-void text-white">
        <Navbar />
        <Hero />
        <EditorialMarquee />
        <Brands />
        <Services />
        <Manifesto />
        <FoundersCorner />
        <Clients />
        <Testimonials />
        <Enquiry />
        <MapSection />
        <Footer />
        <FloatingActions />
    </main>
);

function App() {
    return (
        <div className="App">
            <SmoothScroll>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-center" theme="light" />
            </SmoothScroll>
        </div>
    );
}

export default App;
